import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges, ChangeDetectionStrategy } from '@angular/core';
import { Router } from '@angular/router';
import { MatTableDataSource } from '@angular/material/table';
import { MatCheckboxChange } from '@angular/material/checkbox';

import { TableColumn } from 'src/app/models/table';
import { TableColumnType } from 'src/app/constants/table';
import { FormArray, FormGroup } from '@angular/forms';
import { MatSlideToggleChange } from '@angular/material/slide-toggle';
import { TableService } from 'src/app/services/table.service';
import { TextType } from 'src/app/constants/text-type';
import { SvgColor, SvgMatType } from 'src/app/constants/icons';
import { HelperService } from 'src/app/services/helper.service';

@Component({
    selector: 'mwp-table-formarray',
    templateUrl: './table-formarray.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class TableFormArrayComponent implements OnChanges {
    @Input() public tableColumns: TableColumn[];
    @Input() public dataSource: MatTableDataSource<any>;
    @Input() public tableId: number;
    @Input() public form: FormGroup;
    @Input() public arrayName: string;
    @Input() public isModal: boolean = false;
    @Input() public header: string;
    @Input() public nameInHeader: string; // variable that goes inside header but is never Translated
    @Input() public translateHeader: boolean = true;
    @Input() public hasControls: boolean;


    @Output() public emitButtonSelection: EventEmitter<any> = new EventEmitter();
    @Output() public emitButtonSelection2: EventEmitter<any> = new EventEmitter();
    @Output() public emitSlideToggleSelection: EventEmitter<any> = new EventEmitter();
    @Output() public emitHyperLink: EventEmitter<any> = new EventEmitter();
    @Output() public emitIconButton: EventEmitter<any> = new EventEmitter();


    public columnType = TableColumnType;
    public renderdColumns: string[] = [];
    public currentId: number;
    public isLoaded: boolean;
    public isSelectAll: boolean;

    constructor(
        private tableService: TableService,
        private router: Router,
        private helperService: HelperService,
    ) {
    }

    ngOnChanges(changes: SimpleChanges): void {
        this.isLoaded = false;
        this.renderdColumns = this.tableService.extractTableColumnNames(this.tableColumns);
        this.currentId = this.tableId;
        this.isLoaded = true;
    }

    // HACK - This automatically updates a header column name when changed
    // How does this work, Only god knows now
    trackByIndex(i: any): any {
        return i;
    }

    public displayElement(tableColumn: TableColumn, type: TableColumnType, element: any): boolean {
        return this.tableService.displayElement(tableColumn, type, element);
    }

    public findElementByColumnName(element: any, column: string, textType: TextType): string {
        return this.tableService.findElementByColumnName(element, column, textType);
    }

    public findSlideToggleCSS(element: any, textType: string): string {
        const value = element[textType];
        if (value)
            return value;

        return textType;
    }

    get formArray(): FormArray {
        return <FormArray>this.form.get(this.arrayName) as FormArray;
    }

    public selectAll(event: MatCheckboxChange, tableColumn: TableColumn): void {
        this.isSelectAll = event.checked;

        this.formArray.controls.map((gaa) => {
            gaa.get(tableColumn.propertyId).setValue(event.checked);
        });
    }

    public selectAllChange(event: MatCheckboxChange, tableColumn: TableColumn): void {
        let l_IsAllChecked: boolean = true;

        this.formArray.controls.map((gaa) => {
            if (!gaa.get(tableColumn.propertyId).value)
                l_IsAllChecked = false;
        });

        this.isSelectAll = l_IsAllChecked;
    }

    public checkBoxChange(event: MatCheckboxChange, tableColumn: TableColumn, element: any): void {
        if (tableColumn.isSingleSelect) {
            this.formArray.controls.map((gaa) => {
                if (element[tableColumn.dataTypePropertyId] != gaa.get(tableColumn.dataTypePropertyId)?.value)
                    gaa.get(tableColumn.propertyId).setValue(false);
            });
        }
    }

    public selection($event: any, tableColumn: TableColumn): void {
        if (tableColumn.columnType == TableColumnType.iconButton) {
            this.emitIconButton.emit($event);
            return;
        }

        if (tableColumn.isButtonSelection2)
            this.emitButtonSelection2.emit($event);
        else
            this.emitButtonSelection.emit($event);
    }

    public openLink(url: string, isNewTab: boolean, isEmit: boolean, $event: any): void {
        if (isNewTab)
            window.open(url, "_blank");
        else if (isEmit)
            this.emitHyperLink.emit($event);
        else
            this.router.navigateByUrl(url);
    }

    public displayIconButton(element: any, tableColumn: TableColumn): boolean {
        return this.tableService.displayIconButton(element, tableColumn);
    }

    public slideToggleChange(event: MatSlideToggleChange, tableColumn: TableColumn, element: any, rowIndex: number): void {
        element[tableColumn.propertyId] = event.checked;
        if (tableColumn.isSingleRowSelect) {
            const l_FormGroup = this.getArrayFormGroup(rowIndex);
            this.tableColumns.forEach((tc: TableColumn) => {
                if (tc.columnType == TableColumnType.slideToggle && tc.propertyId != tableColumn.propertyId) {
                    l_FormGroup.get(tc.propertyId).setValue(false);
                }
            });
        }
        this.emitSlideToggleSelection.emit(element);
    }

    public getArrayFormGroup(index: number): FormGroup {
        return <FormGroup>this.formArray.at(index);
    }

    public findSVGType(element: any, tableColumn: TableColumn): SvgMatType {
        const l_MatId = tableColumn.svgPropertyId ? element[tableColumn.svgPropertyId] : tableColumn.svgCustomName;
        return SvgMatType[this.helperService.getEnumByKey(SvgMatType, l_MatId)];
    }

    public findSVGTypeByCustomName(customName: string): SvgMatType {
        return SvgMatType[this.helperService.getEnumByKey(SvgMatType, customName)];
    }

    public findSVGColor(cssClass: string): SvgColor {
        return SvgColor[this.helperService.getEnumByKey(SvgColor, cssClass)];
    }
}
